export default __webpack_public_path__ + "static/media/check.ca3708b9.svg";